import { z } from "zod";
import type { EditorCore } from "@loumy/contracts";

// D66 Demo-Stub-Editor — minimaler BEWEIS der Erweiterbarkeit, KEIN echtes Feature.
// Ein „Board" aus frei platzierten Knoten; demonstriert den vollständigen
// doc/ui/selection-Round-Trip über alle fünf Regionen (tools/toolbar/viewport/outliner/
// details). Das Dokument ist deklarative Daten (D51) — keine Browser-Compute-Logik hier.

export const DemoBoardNode = z.object({
  id: z.string(),
  label: z.string(),
  x: z.number(),
  y: z.number(),
});
export type DemoBoardNode = z.infer<typeof DemoBoardNode>;

export const DemoBoardDoc = z.object({
  nodes: z.array(DemoBoardNode),
});
export type DemoBoardDoc = z.infer<typeof DemoBoardDoc>;

// Ephemerer UI-State: das aktive Werkzeug koppelt Tools-Panel ↔ Viewport (TUi, D66) —
// genau die „jeder Editor anders"-Mechanik, ohne dass die Shell die Semantik kennt.
export const DEMO_TOOLS = ["select", "add"] as const;
export type DemoTool = (typeof DEMO_TOOLS)[number];
export interface DemoBoardUi {
  activeTool: DemoTool;
}

export const demoBoardCore: EditorCore<DemoBoardDoc, DemoBoardUi> = {
  id: "demo-board",
  label: "Demo Board",
  icon: { name: "tools" },
  documentSchema: DemoBoardDoc,
  createDocument() {
    return { nodes: [] };
  },
  createUiState() {
    return { activeTool: "select" };
  },
  layoutHints: {
    toolbar: { defaultSize: 48, collapsible: false },
    tools: { defaultSize: 200, collapsible: true },
    outliner: { defaultSize: 280, collapsible: true },
    details: { defaultSize: 260, collapsible: true },
  },
};
